import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const SystemHealthPanel = ({ systems }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Aktiv': return 'text-success bg-success/10';
      case 'Warnung': return 'text-warning bg-warning/10';
      case 'Fehler': return 'text-error bg-error/10';
      case 'Wartung': return 'text-muted-foreground bg-muted';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'Aktiv': return 'CheckCircle';
      case 'Warnung': return 'AlertTriangle';
      case 'Fehler': return 'XCircle';
      case 'Wartung': return 'Tool';
      default: return 'Circle';
    }
  };

  return (
    <div className="bg-card rounded-lg p-6 border border-border">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Systemstatus</h3>
        <Button variant="ghost" size="sm" iconName="RefreshCw">
          Aktualisieren
        </Button>
      </div>
      <div className="space-y-3">
        {systems?.map((system) => (
          <div key={system?.id} className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
            <div className="flex items-center gap-3 flex-1">
              <Icon name={system?.icon} size={20} className="text-primary" />
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground">{system?.name}</h4>
                <p className="text-xs text-muted-foreground">{system?.lastSync}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-xs text-muted-foreground">{system?.uptime}</span>
              <span className={`flex items-center gap-1 text-xs px-2 py-1 rounded-full font-medium ${getStatusColor(system?.status)}`}>
                <Icon name={getStatusIcon(system?.status)} size={12} />
                {system?.status}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SystemHealthPanel;